module.exports = __webpack_public_path__ + "static/img/navbar_6.37a889c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/navbar_6.png
// module id = p15L
// module chunks = 25